import styled from 'styled-components';
import { POPPER_HEADER_HEIGHT } from '../../styles/dimensions';

export const JsonModalContent = styled.div`
  max-height: calc(80vh - ${POPPER_HEADER_HEIGHT}px);
  overflow-y: auto;
  line-height: 1.5;
  max-width: 80vw;

  pre {
    text-align: left;
    white-space: pre-wrap;
  }
`;
